export const chinaUsStats = [
	{
		id: "chinaAggregated",
		name: "China",
		// value: 812949,
		// beginDate: 1597881600000,
		// endDate: 1599696000000,
		children: [
			{
				id: "chinaTopic",
				name: "Anti CCP",
				// value: 500000,
				anti: true,
			},
			{
				id: "pchinaTopica",
				name: "Pro CCP",
				// value: 312949,
			},
		],
	},
	{
		id: "usAggregated",
		name: "US",
		// value: 143932,
		// beginDate: 1597881600000,
		// endDate: 1599696000000,
		left: true,
		children: [
			{
				id: "nusTopica",
				name: "Anti US",
				// value: 100000,
				anti: true,
			},
			{
				id: "usTopic",
				name: "Pro US",
				// value: 43932,
			},
		],
	},
];

export const chinaUsStatsMongolia = [
	{
		id: "chinaAggregated",
		name: "China",
		shortLegend: true,
		// value: 812949,
		// beginDate: 1597881600000,
		// endDate: 1599696000000,
		children: [
			{
				id: "monaccp",
				name: "Anti CCP",
				// value: 500000,
				anti: true,
			},
			{
				id: "monpccp",
				name: "Pro CCP",
				// value: 312949,
			},
		],
	},
	{
		id: "usAggregated",
		name: "US",
		shortLegend: true,
		children: [
			{
				id: "monaus",
				name: "Anti US",
				anti: true,
			},
			{
				id: "monpus",
				name: "Pro US",
			},
		],
	},
	{
		id: "russiaAggregated",
		name: "Kremlin",
		shortLegend: true,
		children: [
			{
				id: "monak",
				name: "Anti Kremlin",
				anti: true,
			},
			{
				id: "monpk",
				name: "Pro Kremlin",
			},
		],
	},
];
